/* import __COLOCATED_TEMPLATE__ from './class-group-mpa-points-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class ClassGroupPenaltiesCardComponent extends Component 
{
	@service store;
	@service csv;
	
	@tracked classGroup = null;
	
	@tracked selectedRacePts = null;//pts destination
	@tracked selectedRacePtsName = null;
	
	@tracked selectedPts = null;//pursuit day 1 time
	@tracked selectedPtsName = null;
	
	
	@action
	async selectClassGroup(event)
	{
		var classGroupId = event.target.value;
		
		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			this.classGroup = await this.store.findRecord('classGroup', classGroupId);
			this.calculateRacePoints();
		}
	}
	
	@action
	selectRacePts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedRacePts = null;
			this.selectedRacePtsName = null;
		}
		else
		{
			this.selectedRacePts = ptsCol;
			this.selectedRacePtsName = ptsCol+"Name";
		}
		this.calculateRacePoints();
	}
	
	@action
	selectPts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedPts = null;
			this.selectedPtsName = null;
		}
		else
		{
			this.selectedPts = ptsCol;
			this.selectedPtsName = ptsCol+"Name";
		}
		this.calculateRacePoints();
	}
	
	@action
	async savePoints()
	{
		if(this.classGroup && this.selectedRacePts != null && this.selectedPts != null)
		{
			var results = await this.classGroup.get('results');
			await this.args.event.hasMany('entries').reload();
			var entries = (await this.args.event.get('entries')).slice();
			for(var result of [...results])
			{
				for(var entry of entries)
				{
					if(entry.bib == result.bib)
					{
						entry.set(this.selectedRacePts,result.calculatedRacePoints);
						await entry.save();
					}
				}
			}
		}
		await this.calculateTeamScores();
	}
	
	async calculateRacePoints()
	{
		if(this.classGroup && this.selectedRacePts != null && this.selectedPts != null)
		{
			const results = (await this.classGroup.get('results')).slice();
			for(const result of results)
			{
				const day1Time = result.get(this.selectedPts);
				if(day1Time == null || day1Time == 0 || result.status != "OK")
					result.set('pursuitTime',null);
				else
					result.set('pursuitTime',result.totalTimeInMilliseconds+day1Time*1000);
				
			}
			//sort by pursuit time
			results.sort(this.pursuitSort);
			//sort by school
			results.sort(this.teamSort);
			//mark 6,7th skiers for no points
			let currentTeam = "";
			let teamCount = 0;
			for(const result of results)
			{
				if(result.club != currentTeam)
				{
					currentTeam = result.club;
					teamCount = 0;
				}
				if(teamCount < 6 && result.status == "OK" && result.pursuitTime != null)
				{
					result.validForPoints = true;
				}
				else
				{
					result.validForPoints = false;
				}
				teamCount++;
			}
			//sort by pursuit time
			results.sort(this.pursuitSort);
			//assign points starting at 200
			let currentPoint = 200;
			for(const result of results)
			{
				if(result.validForPoints)
				{
					result.set('calculatedRacePoints',currentPoint);
					currentPoint--
				}
			}
		}
	}
	
	async calculateTeamScores()
	{
		if(this.classGroup && this.selectedRacePts != null && this.selectedPts != null)
		{
			const results = (await this.classGroup.get('results')).slice();
			//sort by pursuit time
			results.sort(this.pursuitSort);
			//sort by school
			results.sort(this.teamSort);
			//collect all the teams
			const teamNames = [];
			for(const result of results)
			{
				if(!teamNames.includes(result.club))
				{
					teamNames.push(result.club);
				}
			}
			const teamResults = [];
			teamResults.push([
				"teamName","score1","score2","score3","score4","total"
			]);
			for(const teamName of teamNames)
			{
				let count = 0;
				let sum = 0;
				const scores = [];
				for(const result of results)
				{
					if(result.club == teamName && count < 4)
					{
						sum += result.calculatedRacePoints;
						count++;
						scores.push(result.calculatedRacePoints);
					}
				}
				teamResults.push([teamName,scores[0]||"",scores[1]||"",scores[2]||"",scores[3]||"",sum]);
			}
			
			this.csv.export(teamResults, {fileName:'teamResults-'+this.classGroup.name+'.csv',withSeparator:false});
		}
	}
	
	get resultsPursuitSorted()
	{
		if(this.classGroup == null || this.selectedPts == null || this.selectedRacePts == null)
		{
			return []
		}
		return this.classGroup.get('results').then((rs) => (rs.slice().sort(this.pursuitSort)));
	}
	
	pursuitSort(a,b)
	{
		const aTime = a.pursuitTime;
		const bTime = b.pursuitTime;

		//if both have totalTimes, and are OK sort by them
		if(aTime != null && bTime != null && (a.status == "OK" && b.status == "OK"))
		{
			return aTime>bTime ? 1 : aTime<bTime ? -1 : (a.id>b.id ? 1:-1);
		}
		if(aTime == null && bTime == null)
		{
			return 0;
		}
		if(aTime == null)
		{
			return 1;
		}
		if(bTime == null)
		{
			return -1;
		}
		if(a.status != "OK")
		{
			return 1;
		}
		if(b.status != "OK")
		{
			return -1;
		}
		return 0;
	}
	
	teamSort(a,b)
	{
		const aClub = a.club || "";
		const bClub = b.club || "";
		return aClub.localeCompare(bClub);
	}
}